<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px;">
        <div class="p-3">
            <Gallery :images="imagesForGallery" :keep-aspect-ratio="true" passClasses="max-h-[500px]" />
        </div>
        <div class="flex flex-col lg:flex-row pt-12 md:pt-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full lg:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Biene Garten Kirche</h1>
                    <p class="text-lg text-gray-500 mt-3">Roldisleben</p>
                    <div class="flex sm:flex-row flex-col items-start gap-4 sm:items-center p-3 shadow-md rounded-md mt-5 max-w-[550px] bg-white">
                        <img src="/assets/kirchen/roldisleben/bgk-logo.webp" class="h-36 object-contain">
                        <p class="text-sm"><span class="font-bold text-base">Logo der Biene Garten
                                Kirche</span><br>Roldisleben</p>
                    </div>
                    <!-- <p class="mt-5 max-w-lg lg:max-w-xl">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                        diam nonumy
                        eirmod
                        tempor
                        invidunt ut labore
                        et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
                        et.</p>
                    <a href="https://bienen-garten-kirche.info/"
                        class="text-sm text-gray-500 mt-5 hover:text-primary-default hover:underline flex max-w-96 gap-2 items-center">
                        <svg class="w-5 h-5 mb-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 12H5m14 0-4 4m4-4-4-4" />
                        </svg>

                        Mehr erfahren auf der offiziellen Website
                    </a> -->
                </div>
                <div>
                    <h2 class="font-written text-4xl">Infopunkt und Gemeinwohlschrank</h2>
                    <p class="text-lg text-gray-500 mt-3">Der nächste Schritt?</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        Als Modellprojekt der IBA Thüringen in Kooperation mit der Evangelischen Kirche in
                        Mitteldeutschland erhielt die Bienen-Garten-Kirche in Roldisleben im vergangenen Jahr
                        Unterstützung durch ein kuratorische Begleitung der Gesamtmaßnahme durch die Firmen Chezweitz
                        aus Berlin und Cuadrilla aus Rastenberg. Diese dient der Qualitätssicherung des Gesamtprojektes
                        im Rahmen der IBA. Die einzelnen Ideen und Umsetzungen werden mit professioneller Hilfe
                        gestalterisch und praktisch weiterentwickelt. In diesem Zusammenhang entstand 2021 der Infopunkt
                        "Gemeinwohlschrank", der künftig einen zentralen Anlaufpunkt in der Bienen-Garten-Kirche
                        darstellt. Dort werden unter anderem verschiedene Produkte, etwa Honig, Kerzen oder anderes zum
                        Mitnehmen angeboten. Vor allem aber dient der Infopunkt, wie der Name schon sagt, der
                        Informationsvermittlung. Hier erfahren Sie wissenswertes über das Projekt der
                        Bienen-Garten-Kirche, sammeln spannende Erkenntnisse über die Welt der Bienen und können sich
                        auch über den historischen Hintergrund der Kirche St. Peter und Paul zu Roldisleben informieren.
                        Das Vorhaben wurde großzügig durch die Beauftragte der Bunderegierung für Kultur und Medien im
                        Rahmen des Soforthilfeprogramms „Kirchturmdenken. Sakralbauten in ländlichen Räumen: Ankerpunkte
                        lokaler Entwicklung und Knotenpunkte überregionaler Vernetzung“ unterstützt.
                    </p>
                    <div class="flex items-center gap-2 mt-8">
                        <img src="/assets/kirchen/roldisleben/widersense_label.webp" class="h-20 md:h-32 w-auto">
                        <img src="/assets/kirchen/roldisleben/kultur_und_medien_label.webp" class="h-20 md:h-32 w-auto">
                    </div>
                    <p class="mt-8 max-w-lg lg:max-w-xl">
                        Der Info Punkt ist frei für alle BesucherInnen der Bienen-Garten-Kirche zugänglich. Es werden
                        alle Altersgruppen gleichermaßen angesprochen. Der Standort steht ganzjährig zur Verfügung.
                        Zudem werden mehrmals im Jahr Veranstaltungen durchgeführt, Gottesdienste, Feste, thematische
                        Veranstaltungen zu geistlichen, kulturellen, ethischen und ökologischen Themen.

                        2021 fand zum zweiten Mal ein Erntedankgottesdienst mit der Finneck Gemeinschaftsschule "Maria
                        Marta" statt. Zudem feierten wir unter Beachtung notwendiger Maßnahmen zur Eindämmung der
                        Corona-Pandemie ein kleines Kirmes-Fest mit dem ortsansässigen Verein "Kleine Schweiz".

                        Langfristig ist geplant, den Infopunkt durch Ladestationen für Elektrofahrräder zu erweitern. So
                        wird die "Bienen- Garten- Kirche" in Roldisleben zu einem attraktiven Anlaufpunkt für
                        Radwanderer entlang des Finne-Radwegs und der gesamten Saale-Unstrut-Region sowie des
                        nahegelegenen Naturschutzgebietes "Hohe Schrecke". Für die weitere Erschließung der
                        touristischen Nutzung ist es für den Moment sehr wichtig, das spontan anreisende Gäste sofort
                        wichtige Informationen zum Ort, zum Projekt "Bienen-Garten-Kirche und Hinweise zu
                        Kontaktpersonen erhalten können.

                        Durch die gesteigerte Qualität von Gestaltung und Informationsvermittlung wird die
                        Bienen-Garten-Kirche auch für Fachleute in verschiedenen ökologischen Themengebieten aber auch
                        für pädagogische Einrichtungen, Kindertagesstätten, Schulen, Erwachsenenbildung etc.
                        interessant.
                    </p>
                </div>
                <div>
                    <h2 class="font-written text-4xl">Es geht weiter!</h2>
                    <p class="text-lg text-gray-500 mt-3">Förderprojekt der IBA Thüringen nimmt Fahrt auf</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        <span class="font-bold">Thüringer Staatspreis für Baukultur 2021 für IBA Vorhaben »500 kirchen
                            500 ideen«</span>
                        <br>
                        <br>
                        Das Thüringer Ministerium für Infrastruktur und Landwirtschaft (TMIL) lobte Anfang des Jahres
                        erstmals den Thüringer Staatspreis für Baukultur aus. Von insgesamt 75 Einreichungen im
                        Wettbewerb nominierte eine Fachjury 17 Projekte für die engere Wahl. Mit dabei waren auch vier
                        mit der IBA Thüringen verbundene Projekte: »500 kirchen 500 ideen«, »Ein Tor ins Schwarzatal –
                        Bahnhof Rottenbach«, »Initiative Zukunftswerkstatt Schwarzatal« und das »Timber Prototype
                        House«.
                        <br>
                        <br>
                        Der Staatspreis für Baukultur sowie Sonderpreise und Medaillen wurden am Freitag, den 10.
                        September 2021, in einer festlichen Preisverleihung in Weimar feierlich durch Minister Prof. Dr.
                        Benjamin-Immanuel Hoff vergeben. Das IBA Vorhaben »500 kirchen 500 ideen« in Kooperation mit der
                        Evangelischen Kirche Mitteldeutschland und unter Mitwirkung der kuratorischen Projektleitung
                        durch chezweitz Berlin erhielt eine Medaille in der Kategorie
                        »Initiativen/Institutionen/Personen« und wurde stellvertretend für das ganze Projektteam von
                        Ulrike Rothe (IBA Thüringen) und Marcus Schmidt (Evangelische Kirche Mitteldeutschland)
                        entgegengenommen. Ulrike Rothe, Projektleiterin der IBA Thüringen: »Wir freuen uns riesig für
                        alle unsere EKM/IBA Modellkirchen im Rahmen des Gesamtvorhabens STADTLAND:Kirche Thüringen. Die
                        Medaille für Baukultur gibt Kraft für die nächste Etappe bis zum Abschlussjahr der IBA Thüringen
                        2023.«
                    </p>
                    <a href="https://www.iba-thueringen.de/"
                        class="text-sm text-gray-500 mt-5 hover:text-primary-default hover:underline flex max-w-96 gap-2 items-center">
                        <svg class="w-5 h-5 mb-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 12H5m14 0-4 4m4-4-4-4" />
                        </svg>

                        Quelle: https://www.iba-thueringen.de/
                    </a>
                    <div class="flex items-center gap-2 mt-8">
                        <img src="/assets/kirchen/roldisleben/iba_label.webp" class="h-20 md:h-32 w-auto">
                    </div>
                </div>
                <div>
                    <h2 class="font-written text-4xl">Wettbewerb</h2>
                    <p class="text-lg text-gray-500 mt-3">Projekt "Biene Garten Kirche"</p>
                    <Gallery :images="imagesForIBA" :keep-aspect-ratio="true" passClasses="mt-5 max-w-lg lg:max-w-xl" />
                    <p class="max-w-lg lg:max-w-xl mt-5">
                        Im Jahr 2017 beteiligte sich die Kirchengemeinde Roldisleben, jetzt Rastenberg-Roldisleben, am
                        Wettbewerb „QuerStadtland:Kirche, Querdenker für Thüringen 2017“ von EKM und IBA. In der
                        Kategorie „Natur“ wurde das Projekt „Bienen-Garten-Kirche Roldisleben“ als IBA Förderpartner
                        ausgewählt. Im Hintergrund des Wettbewerbs steht das Ansinnen, Kirchen im ländlichen Raum einer
                        erweiterten Nutzung zuzuführen und für die Menschen vor Ort neu zu erschließen. Mit der
                        „Bienen-Garten-Kirche“ soll eine Stätte für intergenerationale Begegnungen und den Austausch von
                        Erfahrungen, Wissen und Glauben geschaffen werden. Im Mittelpunkt steht die Erschließung von
                        Garten und Kirche über die rein gottesdienstliche Nutzung hinaus zum Nutzen der Dorfgemeinschaft
                        und als attraktiver Anlaufpunkt für die ganze Region. Verschiedenste kulturelle Angebote sind
                        dabei ebenso im Fokus, wie pädagogische. Im Rahmen des mehrjährigen Gesamtprojektes sollen
                        Kirche und Kirchgarten einen Raum bilden, der Gemeinwohlbewusstsein befördert, Traditionsbildung
                        und -vermittlung begünstigt, kulturgeschichtliches und religiöses Wissen transportiert und zu
                        Reflexion einlädt.
                        <br>
                        <br>
                        Der 2018 zu schaffende Raum unter dem Titel „Bienenglocke“ dient als Zukunftsforum und
                        Denkwerkstatt. Es wird die Auseinandersetzung mit den Folgen industrieller Produktionsweisen
                        befördert. Mittelbar kann dadurch exemplarisch die Umkehrung einer Entwicklung angestoßen
                        werden, wonach im Zuge zunehmender Urbanisierung und Landflucht unter anderem städtische
                        Ballungszentren entstehen, die eine höhere Biodiversität und Insektenrefugien aufweisen, während
                        das Land biologisch und sozial verarmt.

                        Die Bienen sind von ersterem besonders stark betroffen. Jahrtausende lang als Garant guter
                        Ernten und Lieferant wertvoller Rohstoffe genutzt, ist ihre Existenz gefährdet, ohne dass die
                        Folgen dieser Entwicklung derzeit Zeit überhaupt abzuschätzen sind.
                        <br>
                        <br>
                        Die Bienen bilden eine eindrucksvolle Metapher für Gruppen mit hoher Schwarmintelligenz und die
                        darin verborgenen Potentiale, wie eine tragfähige Gemeinschaft oder das gemeinsame Erreichen von
                        Zielen, die dem Einzelnen unerreichbar sind. Indem wir anfangen die Bienen zu schützen, schützen
                        wir auch uns; indem wir anfangen, abseits von wirtschaftlichen Interessen die wesentliche
                        Bedeutung von Acker als Grundlage unser Kunst und Kultur zu begreifen, lernen wir auch das
                        miteinander auf dem Land wieder zu schätzen. Diese Entwicklung bedingt keine gesellschaftliche
                        Homogenität. So vielfältig wie die Natur soll auch eine Vielfalt der Gedanken, des Handelns und
                        der Spezialisierung im Miteinander vertreten sein. Nur eine polymorphe Gemeinschaft, in die sich
                        jeder mit seinen speziellen Fähigkeiten einbringen und in der kontrovers diskutiert werden kann,
                        ist eine stabile und produktive Gemeinschaft.
                        <br>
                        <br>
                        In Zusammenarbeit mit dem Institute of Computational Design aus Stuttgart und gefördert durch
                        das Thüringer Ministerium für Infrastruktur und Landwirtschaft entsteht ein erlebnis- und
                        museumspädagogisch konstruierter Raum, die „Bienenglocke“. Mit der Gestaltung dieser
                        „Bienenglocke“ kann man sowohl einen Bienenkorb als auch an eine Glocke assoziieren. Natur und
                        Kultur bzw. Religion verbinden sich zu einer Form. Die Glocke ruft in die Welt, rüttelt die
                        Menschen wach, ruft in ihrer geistlichen Funktion zu Gebet und fungiert weltlich als
                        Alarmsignal. Der Bienenkorb steht für den Kreislauf der Natur, die schöne Schöpfung, Harmonie
                        und Lebenskraft. Er bildet er eine hoch effiziente und zugleich sehr fragile Struktur. Es wird
                        ein Bezug von sichtbarer-ursprünglicher, moderner-technologischer und unsichtbarer-spiritueller
                        Welt hergestellt.
                    </p>
                </div>
            </div>
            <div class="text-left sticky mt-16 lg:mt-0 flex-auto px-3 lg:px-0 pr-3 lg:pr-12 lg:pr-24 top-[115px] h-min">
                <div class="flex-auto lg:w-auto flex flex-col items-center">
                    <div class="flex flex-col w-full gap-3">
                        <!-- <p class="text-md text-gray-500 px-1">Kontakt</p>
                        <div class="flex flex-col w-full p-6 rounded-md bg-white"
                            style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">

                            <div>
                                <p class="font-bold">Hans Zimmer (Ansprechpartner)</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Mobil</span> <a
                                            href="tel:017670817415" class="hover:underline">0123 / 456789</a></p>
                                    <p class="flex"><span class="w-14 font-bold mr-8">E-Mail</span> <a href="mailto:"
                                            class="hover:underline">zimmer.hans@email.com</a>
                                    </p>
                                </div>
                            </div>

                            <div class="mt-8">
                                <p class="font-bold">Begehung und Führung</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex">- nach absprache -
                                    </p>
                                </div>
                            </div>

                            <div class="mt-8">
                                <p class="font-bold">Website</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><a href="https://biene-garten-kirche.info"
                                            class="hover:underline">https://biene-garten-kirche.info</a>
                                    </p>
                                </div>
                            </div>
                        </div> -->
                        <div v-if="data.length > 0">
                            <p class="text-md text-gray-500 px-1 mt-3 mb-3">Nächster Gottesdienst</p>
                            <div class="flex flex-col gap-3">
                                <template v-for="(i, n) in data.slice(0, 2)" :key="n">
                                    <div class="bg-white rounded-md flex flex-col gap-3 text-left overflow-hidden select-none"
                                        style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                                        <div class="flex items-center justify-between px-3 py-2 bg-gray-500">
                                            <p class="text-sm text-white">{{ i.date }}</p>
                                            <p class="text-sm text-white">{{ i.time }}</p>
                                        </div>
                                        <div class="flex gap-10 p-3">
                                            <div>
                                                <p class="font-bold">{{ i.title }}</p>
                                                <p class="text-sm text-gray-500">Thema des Gottesdienstes</p>
                                            </div>
                                            <div class="ml-auto text-right" :title="i.location">
                                                <p>{{ i?.location.split(',').reverse()[0].replace(/\d+/g, "") }}</p>
                                                <p class="text-sm text-gray-500">Ort</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <p class="mt-4 italic text-right text-xs text-gray-500">Daten von <a
                                    href="https://kg-rastenberg.ekmd-online.de/gottesdienste/"
                                    class="hover:underline hover:text-primary-default font-bold">kg-rastenberg.ekmd-online.de</a>
                                bereitgestellt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-11/12 mx-auto h-0.5 rounded-md bg-gray-300 mt-16 lg:mt-28"></div>
        <div class="flex flex-col px-12 p-12 lg:p-24 text-left">
            <h2 class="font-written text-4xl">Räumlichkeiten</h2>
            <p class="text-lg text-gray-500 mt-3">Gemeinderaum, Kirche</p>
            <div class="mt-5 flex flex-wrap sm:flex-nowrap gap-2">
                <div class="w-96 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/roldisleben/gemeinderaum-1.webp" class="w-full aspect-[4/3] object-cover">
                    <div class="p-3 mt-3">
                        <p class="text-sm">Gemeinderaum</p>
                    </div>
                </div>
                <div class="w-96 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/roldisleben/gemeinderaum-2.webp" class="w-full aspect-[4/3] object-cover">
                    <div class="p-3 mt-3">
                        <p class="text-sm">Gemeinderaum</p>
                    </div>
                </div>
                <div class="w-96 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/roldisleben/kirche-1.webp" class="w-full aspect-[4/3] object-cover">
                    <div class="p-3 mt-3">
                        <p class="text-sm">Kirche</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Gallery from "@/components/gallery.vue";

export default {
    name: "Rolisleben",
    data() {
        return {
            data: [],
            imagesForIBA: [
                {
                    url: "/assets/kirchen/roldisleben/iba-1.webp",
                    alt: "IBA 1"
                },
                {
                    url: "/assets/kirchen/roldisleben/iba-2.webp",
                    alt: "IBA 2"
                },
                {
                    url: "/assets/kirchen/roldisleben/iba-3.webp",
                    alt: "IBA 3"
                },
                {
                    url: "/assets/kirchen/roldisleben/iba-4.webp",
                    alt: "IBA 4"
                },
                {
                    url: "/assets/kirchen/roldisleben/iba-5.webp",
                    alt: "IBA 5"
                },
                {
                    url: "/assets/kirchen/roldisleben/iba-6.webp",
                    alt: "IBA 6"
                },
                {
                    url: "/assets/kirchen/roldisleben/iba-7.webp",
                    alt: "IBA 7"
                }
            ],
            imagesForGallery: [
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-1.webp",
                    alt: "Roldisleben 1"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-2.webp",
                    alt: "Roldisleben 2"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-3.webp",
                    alt: "Roldisleben 3"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-4.webp",
                    alt: "Roldisleben 4"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-5.webp",
                    alt: "Roldisleben 5"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-6.webp",
                    alt: "Roldisleben 6"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-7.webp",
                    alt: "Roldisleben 7"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-8.webp",
                    alt: "Roldisleben 8"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-9.webp",
                    alt: "Roldisleben 9"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-10.webp",
                    alt: "Roldisleben 10"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-11.webp",
                    alt: "Roldisleben 11"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-12.webp",
                    alt: "Roldisleben 12"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-13.webp",
                    alt: "Roldisleben 13"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-14.webp",
                    alt: "Roldisleben 14"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-15.webp",
                    alt: "Roldisleben 15"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-16.webp",
                    alt: "Roldisleben 16"
                },
                {
                    url: "/assets/kirchen/roldisleben/roldisleben-17.webp",
                    alt: "Roldisleben 17"
                }
            ]
        }
    },
    components: {
        Gallery
    },
    async created() {
        this.data = (await this.$userStore.getData()).filter(f => f.location.includes("Roldisleben"));
    }
}
</script>